
<mat-card class="slidecontent">

    <div class="headcontent">
        <div class="pophead">
            <h3>Edit Module</h3>
        
            <mat-icon (click)="close()" class="close">close</mat-icon>
        
        </div>
    </div>
    
        <div class="dialog_content">
        
            <form [formGroup]="updateModuleform">
        
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>Module Name</mat-label>
                        <input matInput maxlength="30" placeholder="Module Name" formControlName="moduleName"
                            [(ngModel)]="updateModuleDetail.moduleName">
                        <mat-error>
                            This field is required
                        </mat-error>
                    </mat-form-field>
                </div>
        
                <div fxLayout="row" fxLayoutAlign="start start">
        
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>Module Route</mat-label>
                        <input matInput maxlength="30" placeholder="Module Route" formControlName="moduleRoute"
                            [(ngModel)]="updateModuleDetail.moduleRoute">
                        <mat-error>
                            This field is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-element">
                    <mat-checkbox formControlName="isActive" color="primary" [(ngModel)]="updateModuleDetail.isActive">Active</mat-checkbox>
                </div>
            </form>
        </div>
    
    
    <div class="actionBtn">
    
        <button mat-flat-button class="cancel" (click)="close()">Cancel</button>
        <button mat-flat-button class="calltoaction" type="submit" [disabled]="!updateModuleform.valid"
        (click)="updateModule()" color="primary">Update</button>
    </div>
</mat-card>
<div class="overlay" (click)="close()" ></div>
  